/**
 * @ignore
 * Created by daletan on 8/25/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const PriceStore = require('../../../global/stores/PriceStore.es.js');
const TourStore = require('../../../components/Tour/TourStore');

// Components
const Tour = require('../../../components/Tour/Tour');
const DetailsReturnLink = require('./DetailsReturnLink');

// Helpers
const get = require('lodash.get');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const tourTracking = require('../../../global/tracking/tourTracking');
const { type: { TRADE_TOUR } } = TourStore;
const SV = require('server-vars');

// Styles
const styles = require('./shipping-styles.scss');

const DetailsReturn = props => {
    const { tradeTour, copy, item, userId, context } = props;
    const { returnTitle } = copy;
    const returnCopy = get(item, 'returnPolicy.buyerCopy.returnCopy', '');
    return (
        <div className="pdp-shipping-entry-content-container">
            <div className="pdp-details-entry-title-container">
                <Tour
                    dataTn="details-returns-trade"
                    step={5}
                    {...tradeTour}
                    className={styles.shippingTitle}
                >
                    <span className="pdp-shipping-entry-title">{returnTitle}</span>
                </Tour>
            </div>
            <div className={`pdp-shipping-entry ${styles.returnPolicyCopy}`}>
                <p className="pdp-shipping-entry-content" data-tn="return-copy">
                    {returnCopy}
                </p>
            </div>
            <div className="return-modal-link" data-tn="return-modal-link">
                <DetailsReturnLink
                    context={context}
                    href="#"
                    text="View details"
                    item={item}
                    userId={userId}
                />
            </div>
        </div>
    );
};

DetailsReturn.propTypes = {
    context: PropTypes.object,
    item: PropTypes.object,
    userId: PropTypes.string,
    tradeTour: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired,
};

module.exports = Relay.createContainer(
    provideContext(
        connectToStores(DetailsReturn, [ItemStore, PriceStore, TourStore], context => {
            const itemStore = context.getStore(ItemStore);
            const item = itemStore.getItem();
            const priceStore = context.getStore(PriceStore);
            const { priceDisplays } = priceStore.processPrice(item);
            const tourStore = context.getStore(TourStore);
            return {
                copy: itemStore.getCopy().shipping,
                tradeTour: {
                    type: TRADE_TOUR,
                    subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                    copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                    isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                    currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                    totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                    onOpen: tourTracking.trackOpen,
                    onClose: tourTracking.trackClose,
                },
            };
        })
    ),
    {
        initialVariables: {
            userId: null,
        },
        fragments: {
            item: ({ userId }) => Relay.QL`
            fragment on Item {
                ${DetailsReturnLink.getFragment('item', { userId })}
                returnPolicy(userId: $userId) {
                    buyerCopy {
                        returnCopy
                    }
                }
            }
        `,
        },
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsReturns.jsx